<template>
  <v-flex>
    <modal class="reset-input">
      <template v-slot:headline>{{ $t('setting_title_select_region') }}</template>

      <div class="card-label">{{ $t('profile_region') }}</div>
      <v-form v-model="valid" ref="form" @submit.prevent>
        <v-select :items="getRegions" :rules="selectRules" item-text="name" item-value="name" v-model="region" outline></v-select>
      </v-form>
      <v-flex v-html="$t('region_select_warning_text')"></v-flex>
      <template v-slot:buttons>
        <Button color="primary" flat @click.native="chooseRegion()">{{ $t('action_ok') }}</Button>
      </template>
    </modal>
  </v-flex>
</template>

<script>
import store from '@/store';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapActions } = createNamespacedHelpers('commonState');
import { getterTypes, actionTypes } from '@/views/common/store/common.moduletypes';
import { selectRules } from '@/services/form.rules';

import Button from '@/components/ui/Button';
import Modal from '@/components/ui/Modal';

function initialState() {
  return {
    region: null,
    valid: false,
    selectRules
  };
}
export default {
  props: {
    changeModalState: Function
  },
  components: {
    Button,
    Modal
  },
  data: () => {
    return initialState();
  },
  computed: {
    ...mapGetters([getterTypes.getRegions]),
    getRegions() {
      return this[getterTypes.getRegions];
    }
  },
  methods: {
    ...mapActions([actionTypes.getRegions]),
    updateRegion() {
      this[getterTypes.getRegions].forEach(region => {
        if (region.name === this.region) {
          localStorage.setItem('region', JSON.stringify(region));
        }
      });
    },
    chooseRegion() {
      if (this.$refs.form.validate()) {
        this.updateRegion();
        this.$nextTick(() => {
          store.commit('setRegionsNotSelected', false);
        });
      }
    }
  },
  mounted() {
    this[actionTypes.getRegions]();
  },
  created() {
    const region = JSON.parse(localStorage.getItem('region'));
    if (region && region.name) {
      this.region = region.name;
    }
  }
};
</script>

<style lang="scss" scoped></style>
